export enum ValueTypeSimbolEnum {
  Amount = '$',
  Percentage = '%',
}